<div id="background-check" class="flex">
  <div name="right-banner" class="hidden md:block flex justify-center md:w-1/2 px-20">
    <div class="mb-8 flex flex-col justify-center">
      <div class="pt-12 pb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty.thumb}}>
      </div>
      <div class="flex justify-between items-end">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty.baths}}</span> ba | <span
              class="font-bold">{{modelProperty.sqft}}</span> sqft</p>
        </div>
      </div>
      <div class="pb-4">
        <div>{{modelProperty.title}}</div>
      </div>
      <div>
        <div *ngIf="splashHTML != null" class="bg-white h-32" [innerHTML]="splashHTML"></div>
      </div>
    </div>
  </div>
  <div name="main" class="p-8 flex flex-col sm:w-auto md:w-1/2 bg-white">
    <div class="flex flex-col sm:w-auto md:hidden p-8">
      <div class="mb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty.thumb}}>
      </div>
      <div class="flex justify-between items-end ">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty.baths}}</span> ba | <span
              class="font-bold">{{modelProperty.sqft}}</span> sqft</p>
        </div>
      </div>
      <div>
        <div>{{modelProperty.title}}</div>
      </div>
    </div>
    <div class="md:px-16">
      <div>
        <div class="pb-4">
          <h2 class="text-4xl my-2 use-rhetorik-sans">Rental Application</h2>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">1/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Contact Information</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/basic" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">2/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Personal Information</h2>
              <p>Driver’s license, social security, marital status, children and pets</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/personal" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">3/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Residency History</h2>
              <p>Two years of residency history information</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/residency" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">4/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Employment Information</h2>
              <p>Two years of employment information</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/employment" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div *ngIf="verifastEnabled" class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">5/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Income & Identity</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/verifast" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div *ngIf="!verifastEnabled" class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">5/{{totalApplicationSteps}}</h2>
          </div>
          <div *ngIf="verifastEnabled"  class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">6/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Verify Income</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/documents" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div *ngIf="!verifastEnabled" class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">6/{{totalApplicationSteps}}</h2>
          </div>
          <div *ngIf="verifastEnabled" class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">7/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Background Check</h2>
              <p>You have agreed to the Terms and Conditions</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/background-check" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex box-border-active pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">{{currentApplicationStep}}/{{totalApplicationSteps}}</h2>
          </div>
          <div class="col-span-9">
            <h2 class="text-lg font-bold my-6">Additional Applicants</h2>
          </div>
        </div>
      </div>
      <div id="dashboard" class="flex flex-col">
        <div class="sm:w-auto flex justify-center border-0">
          <div class="grid auto-rows-fr grid-cols-1 sm:grid-cols-2 sm:gap-8">
            <div class="my-4 text-center flex flex-col bg-beige-tricon p-4" *ngFor="let applicant of applicants">
              <div>
                <div class="dashboard-card" [ngClass]="{'add-applicant': applicant.FirstName == 'Add Applicant'}">
                  <div class="card-content">
                    <h2 class="text-lg font-bold pb-4">{{applicant.FirstName}} {{applicant.LastName}}</h2>
                    <p
                      [ngClass]="{'applicant-incomplete': applicant.ApplicantStatus == 'Application Incomplete' || applicant.ApplicantStatus == 'Invite Unaccepted' || applicant.ApplicantStatus == 'Missing Contact Details', 'applicant-complete': applicant.ApplicantStatus == 'Complete'}">
                      <span class="text-green-500" *ngIf="applicant.ApplicantStatus == 'Complete'"><i
                          class="material-icons">check_circle</i></span>
                      <span class="text-red-500"
                        *ngIf="applicant.ApplicantStatus == 'Application Incomplete' || applicant.ApplicantStatus == 'Invite Unaccepted' || applicant.ApplicantStatus == 'Missing Contact Details'">
                        <i class="material-icons">error</i>
                      </span> {{applicant.ApplicantStatus}}
                    </p>
                    <p class="pt-8 flex" *ngIf="applicant.ApplicantStatus == 'Add Another Applicant'">
                      <button mat-flat-button color="accent" class="px-4" *ngIf="RentalApplicantKey == PrimaryApplicant"
                        [ngClass]="{'applicant-incomplete': applicant.ApplicantStatus == 'Application Incomplete'}"
                        (click)="addApplicantClick()">{{applicant.ApplicantStatus.toUpperCase()}}</button>
                      <button mat-flat-button color="accent" class="btn btn-inverse"
                        *ngIf="RentalApplicantKey != PrimaryApplicant"
                        [ngClass]="{'applicant-incomplete': applicant.ApplicantStatus == 'Application Incomplete' || applicant.ApplicantStatus == 'Missing Contact Details'}"
                        (click)="applicantClick()">{{applicant.ApplicantStatus.toUpperCase()}}</button>
                    </p>
                    <div>
                      <p class="application-edit-button"
                        *ngIf="applicant.ApplicantStatus != 'Add Another Applicant' && applicant.IsPrimary != true && applicant.IsInvite != true && RentalApplicantKey == PrimaryApplicant && applicant.RentalApplicantParentKey == PrimaryApplicant">
                        <button mat-flat-button color="accent" class="px-4 mt-4" (click)="editApplicant(applicant)">EDIT
                          APPLICANT</button>
                      </p>
                    </div>
                    <div>
                      <p class="application-button"
                        *ngIf="applicant.ApplicantStatus != 'Add Another Applicant' && applicant.IsPrimary != true && RentalApplicantKey == PrimaryApplicant">
                        <button mat-flat-button color="accent" class="px-4 mt-4"
                          (click)="removeApplicantClick(applicant)">REMOVE APPLICANT</button>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right">
          <button mat-flat-button class="text-right" class="h-10 px-6 my-2" color="primary" *ngIf="PrimaryApplicant"
            type="button" (click)="continue()">CLICK TO PROCEED</button>
          <button mat-flat-button class="text-right" class="h-10 px-6 my-2" color="primary" *ngIf="!PrimaryApplicant"
            type="button" disabled>CLICK TO PROCEED</button>
        </div>
      </div>
    </div>
  </div>
